import {Command} from "../decorators/command.decorator";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to delete an issue status entity.
 * Accepts the full entity so that downstream listeners (notification, cache invalidation,
 * undo/redo) have access to the deleted state. The transformer extracts the UID for the
 * backend payload.
 */
@Command({type: `delete`, prototype: IssueStatus})
export class DeleteIssueStatusCommand extends AbstractCommand<IssueStatus> {

    public name = CommandName.DELETE_ISSUE_STATUS;

    public tags: string[] = [`entity`, `delete`, `issue-status`];

    constructor(payload: IssueStatus) {
        super('issue-status', payload.uid, payload);
    }
}
